export default __webpack_public_path__ + "static/media/feeling_3_mobile_view.141d7bbe.svg";